module.exports = __webpack_public_path__ + "static/media/D7.bcb7662f.png";